export const CHANGESPERVISEDETAIL = 'changeSuperviseDetail'